

import CreateServiceMeshHeader from './CreateServiceMeshHeader';
import CreateServiceMeshForm from './CreateServiceMeshForm';

export default function CreateServiceMesh() {
    return (
        <div>
            {/* 顶部标题 */}
            <CreateServiceMeshHeader />
            {/* 中间表单 */}
            <CreateServiceMeshForm />
        </div>
    );
}
